import { createFileRoute, notFound, redirect, useLoaderData } from '@tanstack/react-router'
import { AssetNotFound } from '../../components/errors/NotFound.tsx'
import { assetQuery, siteQuery } from '../../data/assets.ts'
import { useProtections } from '../../data/protections/useProtections.ts'
import { AssetForm } from '../../features/assets/AssetForm.tsx'

export const Route = createFileRoute('/_app/assets/$id_/edit')({
	component: RouteComponent,
	notFoundComponent: () => <AssetNotFound />,
	beforeLoad: async ({ context: { queryClient, impersonation, isAdmin, sub } }) => {
		const hasProtectionsSub = sub.features.includes('protections')
		if (!isAdmin || (!impersonation && !hasProtectionsSub)) {
			throw redirect({ to: '/' })
		}
		const [assets, sites] = await Promise.all([
			queryClient.ensureQueryData(assetQuery(impersonation, { enabled: hasProtectionsSub })),
			queryClient.ensureQueryData(siteQuery(impersonation, { enabled: hasProtectionsSub })),
		])
		return { assets, sites }
	},
	loader: ({ context: { assets, sites }, params: { id } }) => {
		const asset = assets.find((a) => a.id === id)
		if (!asset) throw notFound()
		const childSites = sites.filter((site) => site.parentVrn && site.parentVrn === asset.site.vrn)
		return { asset, childSites }
	},
})

function RouteComponent() {
	const { asset, childSites } = useLoaderData({ from: '/_app/assets/$id_/edit' })
	const { assetProtections } = useProtections()
	if (assetProtections[asset.vrn]) {
		throw notFound()
	}
	return <AssetForm editAsset={asset} assetLabels={childSites} />
}
